import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import './scss/Navigation.scss';
import { logout, isAdmin } from './utils/auth';
import { authService } from './services/authService';
import { FaRunning } from 'react-icons/fa';

function Navigation({ onNavigate }) {
  const isManager = sessionStorage.getItem('is_manager') === 'true';  // Check for string 'true' to identify manager
  const userType = sessionStorage.getItem('user_type');
  const teamId = sessionStorage.getItem('selected_team_id');
  const teamType = sessionStorage.getItem('selected_team_type');
  const [childName, setChildName] = useState('');
  const isParent = userType === 'parent' || sessionStorage.getItem('is_parent') === 'true';
  const isAcademyPlayer = teamType === 'academy';

  // Fetch child name for parents
  useEffect(() => {
    if (isParent) {
      const fetchChildName = async () => {
        const playerId = sessionStorage.getItem('player_id');
        if (playerId) {
          try {
            // Try to fetch the child's name from the API
            const response = await fetch(`${process.env.REACT_APP_API_URL}/get_player.php?player_id=${playerId}`);
            const data = await response.json();
            if (data.success && data.player) {
              const fullName = `${data.player.first_name} ${data.player.last_name}`;
              setChildName(fullName);
              // Also store in sessionStorage for future reference
              sessionStorage.setItem('child_name', fullName);
            }
          } catch (error) {
            console.error('Error fetching child name:', error);
          }
        }
      };
      
      // First check if we already have it in sessionStorage
      const storedChildName = sessionStorage.getItem('child_name');
      if (storedChildName) {
        setChildName(storedChildName);
      } else {
        fetchChildName();
      }
    }
  }, [isParent]);

  const handleNavClick = () => {
    if (onNavigate) {
      onNavigate();
    }
  };

  const menuItems = [
    { path: '/dashboard', label: 'Dashboard', icon: 'fas fa-home' },
    { path: '/matches', label: 'My Matches', icon: 'fas fa-futbol' },
    { path: '/leaderboard', label: 'Leaderboard', icon: 'fas fa-trophy' },
    { path: '/profile', label: 'Profile', icon: 'fas fa-user' },
    { path: '/payments', label: 'Payments', icon: 'fas fa-credit-card' },
  ];

  const isSuperAdmin = authService.isSuperAdmin();

  return (
    <nav className="navigation">
      <ul>
        {!isSuperAdmin && (
          <li><NavLink to="/dashboard" className={({ isActive }) => (isActive ? 'active' : '')} onClick={handleNavClick}>Home</NavLink></li>
        )}
        <li><NavLink to="/matches" className={({ isActive }) => (isActive ? 'active' : '')} onClick={handleNavClick}>Fixtures</NavLink></li>
        
        {/* Show manager-specific links if they are a manager or coach or parent */}
        {(userType === 'manager' || userType === 'coach' || userType === 'parent') && (
          <>
            <li><NavLink to="/trainingSchedule" className={({ isActive }) => (isActive ? 'active' : '')} onClick={handleNavClick}>Training</NavLink></li>
          </>
        )}
        
        {/* Show manager-specific links if they are a manager or coach */}
        {(userType === 'manager' || userType === 'coach') && (
          <>
            <li><NavLink to="/players" className={({ isActive }) => (isActive ? 'active' : '')} onClick={handleNavClick}>Players</NavLink></li>
          </>
        )}
        
        {/* Show Player Attendance link only for admins and coaches */}
        {(authService.isAdmin() || userType === 'coach') && (
          <li><NavLink to="/player-attendance" className={({ isActive }) => (isActive ? 'active' : '')} onClick={handleNavClick}>Player Attendance</NavLink></li>
        )}
        
        {/* Show profile only if NOT a manager user (is_manager !== 'true') */}
        {!isManager && (
          <li><NavLink to="/profile" className={({ isActive }) => (isActive ? 'active' : '')} onClick={handleNavClick}>
            {isParent && childName ? `${childName.split(' ')[0]}'s Player Profile` : 'My Profile'}
          </NavLink></li>
        )}
        
        {/* Match Reports */}
        <li><NavLink to="/match-reports" className={({ isActive }) => (isActive ? 'active' : '')} onClick={handleNavClick}>Match Reports</NavLink></li>
        
        <li><NavLink to="/leaderboard" className={({ isActive }) => (isActive ? 'active' : '')} onClick={handleNavClick}>Leaderboard</NavLink></li>
        
        {/* Show Parent Resources link for parents */}
        {userType === 'parent' && (
          <li><NavLink to="/parent/resources" className={({ isActive }) => (isActive ? 'active' : '')} onClick={handleNavClick}>Parent Resources</NavLink></li>
        )}
        
        {/* Show Child Access Settings for parents who can respond to matches */}
        {userType === 'parent' && authService.canRespondToMatches(sessionStorage.getItem('player_id')) && (
          <li><NavLink to="/parent/settings" className={({ isActive }) => (isActive ? 'active' : '')} onClick={handleNavClick}>Child Access Settings</NavLink></li>
        )}
        
        <li><NavLink to={`/team/${teamId}`} className={({ isActive }) => (isActive ? 'active' : '')} onClick={handleNavClick}>Team Information</NavLink></li>
        
        <li><NavLink to="/my-account" className={({ isActive }) => (isActive ? 'active' : '')} onClick={handleNavClick}>My Account</NavLink></li>
        
        {/* Help link for all users */}
        <li><NavLink to="/help" className={({ isActive }) => (isActive ? 'active' : '')} onClick={handleNavClick}>Help</NavLink></li>
        
        {/* Show Admin link for admins, managers, and superadmins */}
        {(authService.isAdmin() || authService.isManager() || userType === 'manager' || userType === 'coach' || isSuperAdmin) && (
          <li><NavLink to="/admin" className={({ isActive }) => (isActive ? 'active' : '')} onClick={handleNavClick}>Admin</NavLink></li>
        )}
        { authService.isSuperAdmin() && (
          <li><NavLink to="/pitches" className={({ isActive }) => (isActive ? 'active' : '')} onClick={handleNavClick}>Locations</NavLink></li>
        )}
        <li><a onClick={() => { handleNavClick(); logout(); }} className="logout-button">Log Out</a></li>
      </ul>
    </nav>
  );
}

export default Navigation; 